import { render, staticRenderFns } from "./index.vue?vue&type=template&id=514ef660&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=514ef660&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514ef660",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\clientesapp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('514ef660')) {
      api.createRecord('514ef660', component.options)
    } else {
      api.reload('514ef660', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=514ef660&scoped=true&", function () {
      api.rerender('514ef660', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/commons/svgIcon/index.vue"
export default component.exports